/* eslint-disable react-hooks/exhaustive-deps */
import { React, useMemo, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// Компоненты пользовательского интерфейса
import '../../styles/Kuobzes.css';
import Table from '../Table/Table';
import Modal from '../Modal/Modal';
import EditKuobz from './EditKuobz';
import AddKuobz from './AddKuobz';
import CustomButton from '../CustomElements/CustomButton';
import ResetMesh from '../Brigades/ResetMesh';
import CustomButtonEdit from '../CustomElements/CustomButtonEdit';
import HeaderForObject from '../CustomElements/HeaderForObject';
import CustomButtonDelete from '../CustomElements/CustomButtonDelete';
// Кастомные хуки
import { useRole } from '../../customHook/useRole';
import useTranslations from '../../customHook/useTranslations';
import useInfiniteScroll from '../../customHook/useInfiniteScroll';
// Утилиты
import { defaultCellRender } from '../../utils/formatValueForHTML';
// Действия Redux
import { clearKuobzes, initKuobzesFromServer } from '../../redux/actions/kuobz.action';
import { emitResetMesh } from '../../redux/actions/brigades.action';
import { listenResetMesh } from '../../redux/actions/brigades.action';

import translations from '../../content/PagesContent/DevicePages/devicePageTranslations.json';

function renderNumber(value) {
  return <div className="number-cell">{defaultCellRender(value)}</div>;
}

// Компонент для отображения и управления КУОБЗ

function Kuobzes(props) {
  // получение словаря для статических данных в зависимости от выбранного языка
  const t = useTranslations(translations);
  // Получение функции dispatch для отправки действий в Redux store.
  const dispatch = useDispatch();
  // Получение данных устройств из Redux store
  const kuobzes = useSelector((state) => state.kuobzes);
  const canEdit = useRole('edit');

  // Состояния для отображения компонентов и модального окна
  const [isOpen, setIsOpen] = useState(false);
  const [newKuobzModal, setNewKuobzModal] = useState(false);
  const [editKuobzModal, setEditKuobzModal] = useState(false);
  const [currentKuobz, setCurrentKuobz] = useState();
  const [resetMeshModal, setResetMeshModal] = useState(false);

  // открытие модалки для сброса mesh
  const handleButtonClick = (event, device) => {
    event.stopPropagation();
    setCurrentKuobz(device);
    setResetMeshModal(true);
    setIsOpen(true);
  };

  const [searchInput, setSearchInput] = useState('');

  // хук для запроса данных с учетом параметров поиска фильтрации и сортировки, и контроля скрола
  const { bottomBoundaryRef, handleSearch } = useInfiniteScroll(
    {}, // Данные фильтров
    searchInput, // Строка поиска
    setSearchInput, // Функция для изменения строки поиска
    initKuobzesFromServer, // Функция для инициализации данных
    'kuobzes', // Redux-селектор
    () => {}, // Сброс фильтров
    clearKuobzes, // Очистка стейта
    false // Флаг для остановки запросов
  );

  // сброс mesh
  const handlerConfirmResetMesh = (id) => {
    const payload = { kuobzId: id };
    dispatch(emitResetMesh(payload));
  };

  useEffect(() => {
    //слушаем событие 'reset_mesh_reply'
    dispatch(listenResetMesh());
  }, [dispatch]);

  // Открыть модалку для изменения устройства
  const openKuobz = (event, item) => {
    event.stopPropagation();
    setCurrentKuobz(item);
    setEditKuobzModal(true);
    setIsOpen(true);
  };

  // Открыть модалку для добавления нового устройства
  const addNewDevice = () => {
    setNewKuobzModal(true);
    setIsOpen(true);
  };

  // Закрыть модальное окно
  const closeModal = () => {
    setIsOpen(false);
    setNewKuobzModal(false);
    setEditKuobzModal(false);
    setResetMeshModal(false);
  };

  // Колонки таблицы
  const columns = useMemo(
    () => [
      {
        Header: t?.tableHeaderDeviceId || 'ID устройства',
        accessor: 'id',
        Cell: ({ cell: { value } }) => (
          <div className="table-for-devices_cell_id number-cell">
            <img className="cell-id-img_for-table" src="/image/case.svg" alt="Иконка" style={{ opacity: 1 }} /> {value}
          </div>
        ),
      },
      {
        Header: 'IMEI1',
        accessor: 'sim1Imei',
        Cell: ({ value }) => renderNumber(value),
      },
      {
        Header: 'SIM1',
        accessor: 'sim1Number',
        Cell: ({ value }) => renderNumber(value),
      },
      {
        Header: t?.sim1num || 'Номер SIM 1',
        accessor: 'sim1Serial',
        Cell: ({ value }) => renderNumber(value),
      },
      {
        Header: 'IMEI2',
        accessor: 'sim2Imei',
        Cell: ({ value }) => renderNumber(value),
      },
      {
        Header: 'SIM2',
        accessor: 'sim2Number',
        Cell: ({ value }) => renderNumber(value),
      },

      {
        Header: t?.sim2num || 'Номер SIM 2',
        accessor: 'sim2Serial',
        Cell: ({ value }) => renderNumber(value),
      },
      ...(canEdit
        ? [
            {
              Header: t?.confirmButton || 'Изменить',
              disableSorting: true, // Флаг для отключения сортировки
              Cell: ({ row }) => (
                <div className="">
                  <CustomButtonEdit
                    onClick={(event) => {
                      openKuobz(event, row?.original);
                    }}
                  />
                </div>
              ),
            },
            {
              Header: t?.tableHeaderResetMesh || 'Сбросить Mesh',
              disableSorting: true, // Флаг для отключения сортировки
              Cell: ({ row }) => (
                <div className="">
                  <CustomButtonDelete
                    margin="0  var(--sadr-font-size-5) "
                    disabled={false}
                    onClick={(event) => {
                      handleButtonClick(event, row?.original);
                    }}
                  />
                </div>
              ),
            },
          ]
        : []),
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [kuobzes, t]
  );

  return (
    <div className="kuobzes">
      <HeaderForObject
        searchInput={searchInput}
        onFilterChange={(e) => {
          setSearchInput(e?.target?.value);
        }}
        onFilterSubmit={handleSearch}
      />
      <Table
        data={kuobzes}
        columns={columns}
        showGlobalSearch={false}
        bottomBoundaryRef={bottomBoundaryRef}
        arrLength={kuobzes.length}
        disableInternalSorting
      />

      <div className="kuobze_btn-container">
        <CustomButton text={t?.addKuobzButton || '+ Добавить новый КУОБЗ'} onClick={addNewDevice} />
      </div>
      {/* Модальное окно */}
      <Modal isOpen={isOpen} onClose={closeModal} width="var(--sadr-font-size-1000)" height="90%" top="48%">
        {/* Компонент для добавления нового устройства */}
        {newKuobzModal && <AddKuobz closeModal={closeModal} t={t} />}
        {/* Компонент для просмотра устройства */}
        {editKuobzModal && (
          <EditKuobz closeModal={closeModal} currentKuobz={currentKuobz} setCurrentKuobz={setCurrentKuobz} t={t} />
        )}
        {resetMeshModal && (
          <ResetMesh
            closeModal={closeModal}
            confirmReset={false}
            handlerConfirm={handlerConfirmResetMesh}
            device={currentKuobz}
            t={t}
          />
        )}
      </Modal>
    </div>
  );
}

export default Kuobzes;
